<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Redigera bemanningsavvikelse
      </v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col>
            <v-text-field
              label="Tågnummer"
              outlined
              type="number"
              v-model.number="model.train_number"
              :rules="[required]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu
              ref="datepicker"
              :close-on-content-click="false"
              v-model="datepicker"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :rules="[validDate]"
                  v-model="model.duty_date"
                  label="Tjänstedatum"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                locale="sv"
                first-day-of-week="1"
                v-model="model.duty_date"
                no-title
                @input="datepicker = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <CrewLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending">
          Redigera bemanningsavvikelse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required, validDate } from '@/common/validationRules'
import CrewLocationFields from './CrewForm/CrewLocationFields.vue'

export default {
  name: 'CrewEditModal',

  components: {
    CrewLocationFields
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    validDate,
    valid: true,
    datepicker: false,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (key === 'uuid') {
        acc[key] = this.model[key]
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})

    this.$store.set('crew/model', {
      ...updateModel
    })
  },

  computed: {
    model: sync('crew/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.updatePending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceCrewDeviationInput!) {
            replaceCrewDeviation(payload: $payload) {
              crew_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload: this.model
          }
        }
      })

      this.updatePending = false
      this.$store.set(`crew/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`crew/data@${this.model.uuid}`, this.model)
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('crew/resetModel')
      this.$emit('close')
    }
  }
}
</script>
